const itemTypes = {
	itemTypes: 'Tipos de item',
	itemType: 'Tipo de item',
	text: 'Texto',
	literature: 'Literatura',
};

export default itemTypes;
